import React, { useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield } = FiIcons;

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 py-16 px-6">
      <div className="max-w-3xl mx-auto bg-slate-900 rounded-2xl shadow-2xl border border-slate-800 p-8 md:p-12">
        <div className="flex items-center gap-4 mb-8 border-b border-slate-800 pb-6">
          <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center">
            <SafeIcon icon={FiShield} className="text-blue-500 text-2xl" />
          </div>
          <h1 className="text-3xl font-bold text-white">Política de Privacidad</h1>
        </div>

        <div className="space-y-8 text-slate-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Información que recopilamos</h2>
            <p>En ProtegeTuRed by ComplianceBOX recopilamos la información que usted proporciona voluntariamente al utilizar nuestra herramienta de diagnóstico. Esto incluye:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1 text-slate-400">
              <li>Información de contacto (nombre, correo electrónico corporativo, nombre de la empresa).</li>
              <li>Respuestas a las preguntas del cuestionario de seguridad.</li>
              <li>Información técnica básica sobre su navegador y dispositivo para asegurar el correcto funcionamiento de la plataforma.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Uso de la información</h2>
            <p>Utilizamos la información recopilada exclusivamente para:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1 text-slate-400">
              <li>Generar su reporte de seguridad personalizado y plan de acción.</li>
              <li>Mejorar la calidad y precisión de nuestra herramienta de diagnóstico.</li>
              <li>Contactarle en caso de que solicite información adicional o soporte.</li>
            </ul>
            <div className="mt-4 p-4 bg-emerald-500/10 border border-emerald-500/20 rounded-lg">
              <p className="text-emerald-400 font-medium">Nos tomamos su privacidad en serio. No vendemos, alquilamos ni compartimos su información personal o los resultados de su diagnóstico con terceros externos con fines comerciales.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. Almacenamiento y Seguridad</h2>
            <p>Los datos ingresados para la generación del reporte se procesan y almacenan localmente en su navegador para permitirle acceder a su historial. Si decide utilizar funcionalidades avanzadas, los datos se transmiten mediante conexiones encriptadas y se almacenan en servidores seguros. Le recomendamos descargar su reporte en formato PDF para conservar una copia segura.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Cambios a esta política</h2>
            <p>Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en esta página.</p>
          </section>

          <section className="pt-6 border-t border-slate-800">
            <h2 className="text-xl font-bold text-white mb-3">Contacto</h2>
            <p>Si tiene alguna pregunta o inquietud sobre nuestra política de privacidad o el manejo de sus datos, por favor contáctenos en: <a href="mailto:hello@compliancebox.org" className="text-blue-400 hover:text-blue-300 transition-colors font-medium">hello@compliancebox.org</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}